<template>
  <div class="demo-block" :class="[blockClass, { hover: hovering }]">
    <div class="meta" ref="meta" v-bind:style="{ height: calculatedHeight + 'px' }">
      <div class="description" v-if="$slots.default">
        <slot></slot>
      </div>
      <div class="highlight">
        <slot name="highlight"></slot>
      </div>
    </div>
    <div
      class="code-block-control"
      style="z-index: 4"
      ref="control"
      @click="isExpanded = !isExpanded"
      :class="{ 'is-fixed': fixedControl }"
      @mouseenter="hovering = true"
      @mouseleave="hovering = false"
    >
      <transition name="arrow-slide">
        <i :class="[{ hovering: hovering }]"></i>
      </transition>
      <button class="btn btn-all-width" style="height: 100%" type="button">
        <i
          class="vik"
          :class="[{ 'vik-up': this.isExpanded, 'vik-down': !this.isExpanded }]"
        ></i>
      </button>
    </div>
  </div>
</template>

<style lang="scss">
.demo-block-control {
  border-top: solid 1px #eaeefb;
  height: 25px;
  box-sizing: border-box;
  background-color: #fff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  text-align: center;
  margin-top: -1px;
  color: #d3dce6;
  cursor: pointer;
  position: relative;

  &.is-fixed {
    position: fixed;
    bottom: 0;
    width: 868px;
  }
  i {
    font-size: 16px;
    line-height: 44px;
    transition: 0.3s;
    &.hovering {
      transform: translateX(-40px);
    }
  }
  > span {
    position: absolute;
    transform: translateX(-30px);
    font-size: 14px;
    line-height: 44px;
    transition: 0.3s;
    display: inline-block;
  }
  &:hover {
    color: #409eff;
    background-color: #f9fafc;
  }
  & .text-slide-enter,
  & .text-slide-leave-active {
    opacity: 0;
    transform: translateX(100px);
  }

  .control-button {
    line-height: 26px;
    position: absolute;
    top: 0;
    right: 0;
    font-size: 14px;
    padding-left: 5px;
    padding-right: 25px;
  }
}
.meta {
  background-color: #fafafa;
  border-top: solid 1px #eaeefb;
  overflow: hidden;
  /*height: 130px;*/
  transition: height 0.2s;
}
</style>

<script type="text/babel">
export default {
  props: {
    minHeight: {
      type: Number,
      default: 150,
    },
  },
  data() {
    return {
      hovering: false,
      isExpanded: false,
      fixedControl: false,
      scrollParent: null,

      calculatedHeight: 150,
    };
  },
  methods: {
    scrollHandler() {
      const { top, bottom, left } = this.$refs.meta.getBoundingClientRect();
      this.fixedControl =
        bottom > document.documentElement.clientHeight &&
        top <= document.documentElement.clientHeight;
      // this.$refs.control.style.left = this.fixedControl ? `${left}px` : "0";
    },
    removeScrollHandler() {
      this.scrollParent &&
        this.scrollParent.removeEventListener("scroll", this.scrollHandler);
    },
  },
  computed: {
    blockClass() {
      return `demo-ed`;
    },
    iconClass() {
      return this.isExpanded ? "el-icon-caret-top" : "el-icon-caret-bottom";
    },
    controlText() {
      return this.isExpanded ? "Collapse" : "Expand";
    },
    codeArea() {
      return this.$el.getElementsByClassName("meta")[0];
    },
    codeAreaHeight() {
      return 450;

      if (this.$el.getElementsByClassName("description").length > 0) {
        return (
          this.$el.getElementsByClassName("description")[0].clientHeight +
          this.$el.getElementsByClassName("highlight")[0].clientHeight +
          20
        );
      }
      return this.$el.getElementsByClassName("highlight")[0].clientHeight;
    },
  },
  watch: {
    isExpanded(val) {
      if (val){
        this.calculatedHeight = this.codeAreaHeight - 22;

        // this.codeArea.style.height = `${this.codeAreaHeight - 22}px`
      } else {
        this.calculatedHeight = this.minHeight
        // this.codeArea.style.height = this.minHeight + "px";
      }
      if (!val) {
        this.fixedControl = false;
        this.$refs.control.style.left = "0";
        this.removeScrollHandler();
        return;
      }
      setTimeout(() => {
        this.scrollParent = document.querySelector(
          ".page-component__scroll > .el-scrollbar__wrap"
        );
        this.scrollParent &&
          this.scrollParent.addEventListener("scroll", this.scrollHandler);
        this.scrollHandler();
      }, 250);
    },
  },

  mounted() {
    this.$nextTick(() => {
      let highlight = this.$el.getElementsByClassName("highlight")[0];
      if (this.$el.getElementsByClassName("description").length === 0) {
        highlight.style.width = "100%";
        highlight.borderRight = "none";
      }
    });
  },
  beforeDestroy() {
    this.removeScrollHandler();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/internal/CodeExpander.vue